// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M1 5A1 1 0 0 1 2 4H22A1 1 0 0 1 23 5V19A1 1 0 0 1 22 20H2A1 1 0 0 1 1 19ZM13 8V10H19V8ZM18 12H13V14H18ZM10.5 10A2.5 2.5 0 1 0 5.5 10 2.5 2.5 0 0 0 10.5 10M8 13.5A3.5 3.5 0 0 0 4.5 17H11.5A3.5 3.5 0 0 0 8 13.5"/>';

/** ID Documents (account). */
const icon: IconData = {
  id: "id-card",
  name: "ID Documents",
  category: "account",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M3 6H21V18H3ZM2 4A1 1 0 0 0 1 5V19A1 1 0 0 0 2 20H22A1 1 0 0 0 23 19V5A1 1 0 0 0 22 4ZM13 8H19V10H13ZM18 12H13V14H18ZM10.5 10A2.5 2.5 0 1 1 5.5 10 2.5 2.5 0 0 1 10.5 10M8 13.5A3.5 3.5 0 0 0 4.5 17H11.5A3.5 3.5 0 0 0 8 13.5"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M22.39 4.08L22.71 4.29 22.92 4.61 23 5V19L22.92 19.39 22.71 19.71 22.39 19.92 22 20H2L1.61 19.92 1.29 19.71 1.08 19.39 1 19V5L1.08 4.61 1.29 4.29 1.61 4.08 2 4H22Z"/></g><path d="M3 6H21V18H3ZM2 4A1 1 0 0 0 1 5V19A1 1 0 0 0 2 20H22A1 1 0 0 0 23 19V5A1 1 0 0 0 22 4ZM13 8H19V10H13ZM18 12H13V14H18ZM10.5 10A2.5 2.5 0 1 1 5.5 10 2.5 2.5 0 0 1 10.5 10M8 13.5A3.5 3.5 0 0 0 4.5 17H11.5A3.5 3.5 0 0 0 8 13.5"/>',
    },
  },
  animation: () => import("../animations/id-card.js"),
};

export default icon;
